import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';

export type NewslettersSubscriptionsLanguageType = Record<NEWSLETTERS, boolean>

export type NewslettersSubscriptionsType = {
  general: { [key in LANGUAGE_CODE]?: { [key in NEWSLETTERS]: boolean } };
  personalized: { [key in NEWSLETTERS]?: boolean };
};

export type RequestNewslettersType = {
  activeSubscriber: boolean;
  subscriptions?: NewslettersSubscriptionsType;
};

export type NewslettersType = {
  activeSubscriber: boolean;
  subscriptions: NewslettersSubscriptionsType | null;
};

export type NewsletterResponseType = {
  activeSubscriber: boolean;
  subscriptions: NewslettersSubscriptionsLanguageType & {
    AHD: boolean;
    AXIS: boolean;
    AXISFR: boolean;
    DELL: boolean;
    DELLFR: boolean;
    HSN: boolean;
    SNF: boolean;
    SNL: boolean;
  };
};

export enum NEWSLETTERS {
  ACE = 'ACE',
  AEN = 'AEN',
  ATN = 'ATN',
  AWN = 'AWN',
  APN = 'APN',
  AXN = 'AXN',
  ACF = 'ACF',
  AEF = 'AEF',
  ATF = 'ATF',
  AWF = 'AWF',
  APF = 'APF',
  AXF = 'AXF',
  AAN = 'AAN',
  AAF = 'AAF',
  PNL = 'PNL',
}
